/** 智能选型 — 联系方式字段（国内：电话+微信；海外：WhatsApp+邮箱） */
export const selectorContactTranslations = {
  zh: {
    selectorContactSection: "联系方式",
    selectorPhoneLabel: "电话",
    selectorPhonePlaceholder: "请输入手机号码",
    selectorWechatLabel: "微信",
    selectorWechatPlaceholder: "请输入微信号（选填）",
    selectorRequired: "必填",
    selectorOptional: "选填",
  },
  en: {
    selectorContactSection: "Contact Information",
    selectorWhatsappLabel: "WhatsApp",
    selectorWhatsappPlaceholder: "Enter your WhatsApp number",
    selectorEmailLabel: "Email",
    selectorEmailPlaceholder: "Enter your email (optional)",
    selectorRequired: "Required",
    selectorOptional: "Optional",
  },
  de: {
    selectorContactSection: "Kontaktdaten",
    selectorWhatsappLabel: "WhatsApp",
    selectorWhatsappPlaceholder: "WhatsApp-Nummer eingeben",
    selectorEmailLabel: "E-Mail",
    selectorEmailPlaceholder: "E-Mail eingeben (optional)",
    selectorRequired: "Pflichtfeld",
    selectorOptional: "Optional",
  },
  pt: {
    selectorContactSection: "Informações de contato",
    selectorWhatsappLabel: "WhatsApp",
    selectorWhatsappPlaceholder: "Digite seu número do WhatsApp",
    selectorEmailLabel: "E-mail",
    selectorEmailPlaceholder: "Digite seu e-mail (opcional)",
    selectorRequired: "Obrigatório",
    selectorOptional: "Opcional",
  },
  es: {
    selectorContactSection: "Información de contacto",
    selectorWhatsappLabel: "WhatsApp",
    selectorWhatsappPlaceholder: "Ingrese su número de WhatsApp",
    selectorEmailLabel: "Correo electrónico",
    selectorEmailPlaceholder: "Ingrese su correo (opcional)",
    selectorRequired: "Obligatorio",
    selectorOptional: "Opcional",
  },
  fr: {
    selectorContactSection: "Coordonnées",
    selectorWhatsappLabel: "WhatsApp",
    selectorWhatsappPlaceholder: "Saisissez votre numéro WhatsApp",
    selectorEmailLabel: "E-mail",
    selectorEmailPlaceholder: "Saisissez votre e-mail (facultatif)",
    selectorRequired: "Obligatoire",
    selectorOptional: "Facultatif",
  },
  it: {
    selectorContactSection: "Informazioni di contatto",
    selectorWhatsappLabel: "WhatsApp",
    selectorWhatsappPlaceholder: "Inserisci il numero WhatsApp",
    selectorEmailLabel: "Email",
    selectorEmailPlaceholder: "Inserisci la tua email (facoltativo)",
    selectorRequired: "Obbligatorio",
    selectorOptional: "Facoltativo",
  },
  hi: {
    selectorContactSection: "संपर्क जानकारी",
    selectorWhatsappLabel: "WhatsApp",
    selectorWhatsappPlaceholder: "अपना WhatsApp नंबर दर्ज करें",
    selectorEmailLabel: "ईमेल",
    selectorEmailPlaceholder: "ईमेल दर्ज करें (वैकल्पिक)",
    selectorRequired: "आवश्यक",
    selectorOptional: "वैकल्पिक",
  },
  ru: {
    selectorContactSection: "Контактная информация",
    selectorWhatsappLabel: "WhatsApp",
    selectorWhatsappPlaceholder: "Введите номер WhatsApp",
    selectorEmailLabel: "Электронная почта",
    selectorEmailPlaceholder: "Введите email (необязательно)",
    selectorRequired: "Обязательно",
    selectorOptional: "Необязательно",
  },
  ko: {
    selectorContactSection: "연락처",
    selectorWhatsappLabel: "WhatsApp",
    selectorWhatsappPlaceholder: "WhatsApp 번호를 입력하세요",
    selectorEmailLabel: "이메일",
    selectorEmailPlaceholder: "이메일 입력 (선택)",
    selectorRequired: "필수",
    selectorOptional: "선택",
  },
  ja: {
    selectorContactSection: "連絡先",
    selectorWhatsappLabel: "WhatsApp",
    selectorWhatsappPlaceholder: "WhatsApp番号を入力",
    selectorEmailLabel: "メール",
    selectorEmailPlaceholder: "メールアドレスを入力（任意）",
    selectorRequired: "必須",
    selectorOptional: "任意",
  },
  th: {
    selectorContactSection: "ข้อมูลติดต่อ",
    selectorWhatsappLabel: "WhatsApp",
    selectorWhatsappPlaceholder: "กรอกหมายเลข WhatsApp",
    selectorEmailLabel: "อีเมล",
    selectorEmailPlaceholder: "กรอกอีเมล (ไม่บังคับ)",
    selectorRequired: "จำเป็น",
    selectorOptional: "ไม่บังคับ",
  },
  tr: {
    selectorContactSection: "İletişim bilgileri",
    selectorWhatsappLabel: "WhatsApp",
    selectorWhatsappPlaceholder: "WhatsApp numaranızı girin",
    selectorEmailLabel: "E-posta",
    selectorEmailPlaceholder: "E-posta girin (isteğe bağlı)",
    selectorRequired: "Zorunlu",
    selectorOptional: "İsteğe bağlı",
  },
  vi: {
    selectorContactSection: "Thông tin liên hệ",
    selectorWhatsappLabel: "WhatsApp",
    selectorWhatsappPlaceholder: "Nhập số WhatsApp",
    selectorEmailLabel: "Email",
    selectorEmailPlaceholder: "Nhập email (không bắt buộc)",
    selectorRequired: "Bắt buộc",
    selectorOptional: "Không bắt buộc",
  },
  nl: {
    selectorContactSection: "Contactgegevens",
    selectorWhatsappLabel: "WhatsApp",
    selectorWhatsappPlaceholder: "Voer uw WhatsApp-nummer in",
    selectorEmailLabel: "E-mail",
    selectorEmailPlaceholder: "Voer e-mail in (optioneel)",
    selectorRequired: "Verplicht",
    selectorOptional: "Optioneel",
  },
  id: {
    selectorContactSection: "Informasi kontak",
    selectorWhatsappLabel: "WhatsApp",
    selectorWhatsappPlaceholder: "Masukkan nomor WhatsApp",
    selectorEmailLabel: "Email",
    selectorEmailPlaceholder: "Masukkan email (opsional)",
    selectorRequired: "Wajib",
    selectorOptional: "Opsional",
  },
  ar: {
    selectorContactSection: "معلومات الاتصال",
    selectorWhatsappLabel: "WhatsApp",
    selectorWhatsappPlaceholder: "أدخل رقم WhatsApp",
    selectorEmailLabel: "البريد الإلكتروني",
    selectorEmailPlaceholder: "أدخل البريد الإلكتروني (اختياري)",
    selectorRequired: "مطلوب",
    selectorOptional: "اختياري",
  },
  pl: {
    selectorContactSection: "Dane kontaktowe",
    selectorWhatsappLabel: "WhatsApp",
    selectorWhatsappPlaceholder: "Wpisz numer WhatsApp",
    selectorEmailLabel: "E-mail",
    selectorEmailPlaceholder: "Wpisz e-mail (opcjonalnie)",
    selectorRequired: "Wymagane",
    selectorOptional: "Opcjonalne",
  },
};
